import { default as Container } from './SubsCancellationReasonsSection.container';
import { default as Component } from './SubsCancellationReasonsSection';
export default Container(Component);
